import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';

@Pipe({
  name: 'daysUntilToday'
})
export class DaysUntilTodayPipe implements PipeTransform {
  transform(endDate: Date): string {
    return formatDistance(endDate, new Date());
  }
}
